import type { CliveRecommendationAvatarType } from '~/components/Clive/types';

/** The live run the side panel speaks for while CMS's own status still says processing. */
export const LIVE_RUN = {
  PROCESSING: 'processing',
  FAILED: 'failed',
} as const;

export type LiveRun = (typeof LIVE_RUN)[keyof typeof LIVE_RUN];

export interface LivePanelContent {
  panelTitle: string;
  panelSubtitle: string;
  avatarType: CliveRecommendationAvatarType;
}
